import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { SInputV2 } from "../../SInputV2";
import { useCommandKey } from "../../hooks";
export const CSSNumberUnitEditor = ({ value, onChangeValue, label, unit, placeholder, min, step, max })=>{
    const getNextState = (currentState, action)=>{
        const literalValue = currentState.value;
        switch(action.type){
            case "INPUT_CHANGE":
                {
                    const { value } = action;
                    const parsedValue = parseFloat(value);
                    return {
                        value: {
                            type: "css-number-unit",
                            unit: unit,
                            value: value
                        }
                    };
                }
        }
        return {
            value: null
        };
    };
    const dispatch = useCallback((action)=>{
        const nextState = getNextState({
            value: value || null
        }, action);
        if (nextState.value) {
            onChangeValue && onChangeValue(nextState.value);
        }
    }, [
        getNextState,
        value
    ]);
    const { isCommandPressed } = useCommandKey();
    const [sliderBounds, setSliderBounds] = useState(undefined);
    const [hovered, setHovered] = useState(false);
    const [mouseDown, setMouseDown] = useState(false);
    useEffect(()=>{
        if (isCommandPressed && (hovered || mouseDown)) {
            setSliderBounds({
                min: 0,
                max: parseInt(value?.value || "0") * 3
            });
        }
    }, [
        isCommandPressed,
        hovered,
        mouseDown,
        setSliderBounds
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        onMouseDown: (e)=>{
            setMouseDown(true);
        },
        onMouseUp: (e)=>{
            setMouseDown(false);
        },
        onMouseLeave: (e)=>{
            setHovered(false);
        },
        onMouseEnter: (e)=>{
            setHovered(true);
        },
        className: `relative bg-grayscale-dark rounded-md border border-white/10 grid overflow-hidden grid-cols-[1fr,auto] items-center`,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-row items-center",
                children: [
                    label && /*#__PURE__*/ _jsx("div", {
                        className: "text-xs opacity-50 px-[6px] flex items-center justify-center border-r border-white/20 h-[30px] ",
                        children: label
                    }),
                    /*#__PURE__*/ _jsx(SInputV2, {
                        borderless: true,
                        tabIndex: 1,
                        min: min,
                        max: max,
                        step: step,
                        type: "number",
                        className: `text-[13px] !pl-1 !pr-0 !h-[30px] text-center !py-0`,
                        value: value?.value || "",
                        placeholder: placeholder,
                        onChange: (e)=>dispatch({
                                type: "INPUT_CHANGE",
                                value: e.target.value
                            }),
                        onKeyDown: (event)=>{
                        // ignore left/right arrow keydown
                        // if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
                        //   event.stopPropagation()
                        // }
                        }
                    })
                ]
            }),
            unit && /*#__PURE__*/ _jsx("p", {
                className: "text-[13px] opacity-70  px-1",
                children: unit
            })
        ]
    });
};
